module.exports = __webpack_public_path__ + "5919ece0.svg";